import React, { useState, useEffect } from "react";
import {
  getCompany,
  getInternshipRequest,
  getInternStudent,
} from "../../api/crud";
import { Drawer } from "@mui/material";
import { useSelector } from "react-redux";
import Select from "react-select";
import { optionsBranch } from "../../data/branch-data";
import { internType } from "../../data/interntype-data";
import { matchOptions, timeSince, parseDate } from "../../utils/function";
import InternPageReview from "../../Components/InternPageReview";
import { useWindowSize } from "../../Hooks/WindowSize";
import { BiBuildings } from "react-icons/bi";
import { IoMdSchool } from "react-icons/io";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import _ from "lodash";
import { BiDotsVerticalRounded } from "react-icons/bi";
import InternPersonsQty from "../../Components/InternPersonsQty";
import { getJoinDataByCompany } from "../../api/crud";

const Approval = () => {
  const optionsNewBranch = [
    {
      label: "ทั้งหมด",
      value: 0,
    },
    ...optionsBranch,
  ];
  const [branchSelected, setBranchSelected] = useState(optionsNewBranch[0]);

  const profile = useSelector((state) => state.profileReducer.profile);
  // const profile = {
  //   b_id: "0",
  //   gpa: "4",
  //   id: "55050419",
  //   m_role: "student",
  //   name: "นายนรุตม์ สาหาร",
  //   status: "0",
  // };

  const [internList, setInternList] = useState([]);
  const [internFilterList, setInternFilterList] = useState([]);
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [studentSelected, setStudentSelected] = useState(null);
  const [internshipRequest, setInternshipRequest] = useState([]);
  const [joinDataByCompany, setJoinDataByCompany] = useState([]);

  const size = useWindowSize();
  let mobileMode = false;
  if (size.width > 1000) {
    mobileMode = false;
  } else if (size.width > 300) {
    mobileMode = true;
  }

  const onHandleBranchSelect = (data) => {
    setBranchSelected(data);

    const filterList = internList.filter((el) =>
      data.value !== 0 ? el.b_id == data.value : el
    );

    const sortList = [...filterList].sort((a, b) => {
      console.log("time", parseDate(b.internDetail.date_create).getTime());
      return (
        parseDate(a.internDetail.date_create).getTime() -
        parseDate(b.internDetail.date_create).getTime()
      );
    });

    setInternFilterList(sortList);
  };

  const fetchInternStudent = async () => {
    const allCompany = await getCompany();
    const internShipReq = await getInternshipRequest();
    const dataByCompany = await getJoinDataByCompany();

    console.log("=== DEBUG DATA ===");
    console.log("All Companies:", allCompany);
    console.log("All Internship Requests:", internShipReq);
    console.log("Student 65050177 requests:", internShipReq.filter(req => req.st_id === "65050177"));

    // setInternshipRequest(internShipReq);

    await getInternStudent()
      .then((res) => {
        console.log("All Students:", res);
        console.log("Student 65050177 from DB:", res.find(s => s.id === "65050177"));
        
        const list = res.filter((el) => {
          const byStatus = el.status_id == 1 || el.status_id == 13;
          const byBranch = el.b_id == profile.b_id;

          return profile && profile.b_id !== "0"
            ? byStatus && byBranch
            : byStatus;
        });
        
        console.log("Filtered list (by status 1 or 13):", list);
        console.log("Is 65050177 in filtered list?", list.find(s => s.id === "65050177"));

      
        const listMatchCompany = list.map((item) => {
          // const internDetail = internShipReq.find(
          //   (req) => req.st_id == item.id
          // );
          const matchingRequests = internShipReq.filter((req) => req.st_id == item.id);
          const internDetail = matchingRequests.sort((a, b) => b.req_id - a.req_id)[0];

          if (item.id === "65050177") {
            console.log("=== Student 65050177 Processing ===");
            console.log("Matching requests:", matchingRequests);
            console.log("Selected internDetail:", internDetail);
            console.log("Looking for company ID:", internDetail?.cp_id);
            console.log("Found company:", allCompany.find((cpn) => cpn.id == internDetail?.cp_id));
          }

          console.log("internDetail", internDetail);

          const itsRequestDetail = internShipReq.map((el) => {
            const ft = res.find((r) => r.id == el.st_id);

            return ft ? { ...el, detail: ft } : el;
          });

          console.log("itsRequestDetail", itsRequestDetail);

          setInternshipRequest(itsRequestDetail);

          return {
            ...item,
            internDetail: internDetail,
            companyDetail: allCompany.find(
              (cpn) => cpn.id == internDetail?.cp_id
            ),
          };
        });

        const sortList = [...listMatchCompany].sort((a, b) => {
          // จัดการกรณีที่ไม่มี date_create
          const dateA = a.internDetail?.date_create 
            ? parseDate(a.internDetail.date_create).getTime() 
            : 0;
          const dateB = b.internDetail?.date_create 
            ? parseDate(b.internDetail.date_create).getTime() 
            : 0;
          
          return dateA - dateB;
        });

        console.log("sortList", sortList);
        console.log("Students with missing data:", sortList.filter(s => !s.internDetail || !s.companyDetail));
        
        // Debug: Check for student 65050177
        const student65050177 = sortList.find(s => s.id === "65050177");
        if (student65050177) {
          console.log("Student 65050177 data:", {
            id: student65050177.id,
            name: student65050177.name,
            hasInternDetail: !!student65050177.internDetail,
            hasCompanyDetail: !!student65050177.companyDetail,
            internDetail: student65050177.internDetail,
            companyDetail: student65050177.companyDetail
          });
        } else {
          console.log("Student 65050177 not found in list");
        }

        setInternList(sortList);
        setInternFilterList(sortList);
      })
      .catch((err) => {
        console.log(err);
      });
    setJoinDataByCompany(dataByCompany);
  };

  useEffect(() => {
    if (profile) {
      fetchInternStudent();
    }
  }, []);

  const onCloseDrawer = () => {
    setStudentSelected(null);
  };

  const displayDrawer = (
    <Drawer
      anchor={mobileMode ? "bottom" : "right"}
      open={studentSelected ? true : false}
      onClose={onCloseDrawer}
    >
      <div
        className=""
        // style={{ height: "80vh" }}
      >
        <InternPageReview data={studentSelected} />
      </div>
    </Drawer>
  );

  console.log({ internFilterList });

  return (
    <main className="content">
      <div className="container p-0">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h1 className="h3 mb-3">อนุมัติคำร้องขอฝึกงาน และสหกิจศึกษา</h1>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h5 className="card-title">
                  รายชื่อนิสิต{" "}
                  {profile &&
                    profile.b_id !== "0" &&
                    matchOptions(optionsBranch, profile.b_id)}{" "}
                  ที่รอการอนุมัติ
                </h5>
              </div>
              <div>
                {profile && profile.b_id == 0 && (
                  <Select
                    options={optionsNewBranch}
                    value={branchSelected}
                    onChange={onHandleBranchSelect}
                  />
                )}
              </div>
            </div>

            <h6 className="card-subtitle text-muted"></h6>
          </div>
          <div className="card-body">
            <div
              id="tasks-upcoming"
              className="row row-cols-1 row-cols-lg-3  row-cols-md-2"
            >
              {!!internFilterList.length &&
                internFilterList.map((el) => {
                  const getStudents = internshipRequest.filter(
                    (item) => item.cp_id == el.companyDetail?.id
                  );

                  const getBranch = getStudents.map((item) => {
                    return item.detail?.b_id;
                  });

                  const getUniqBranch = _.uniq(getBranch);
                  return (
                    <div className="col">
                      <div
                        className="card mb-3 bg-light border"
                        key={el.id}
                        style={{ minHeight: "200px" }}
                      >
                        <div className="card-body p-3">
                          <div className="d-flex align-items-center justify-content-between flex-wrap">
                            <div className="d-flex ">
                              <div className="me-2 fw-bold text-dark">
                                {el.id}
                              </div>
                              <div className="fw-bold-9 text-dark">
                                {el.name}{" "}
                              </div>
                            </div>
                            <div className="dropdown">
                              <BiDotsVerticalRounded
                                size="1.5rem"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              />
                              <ul className="dropdown-menu">
                                <li>
                                  <form
                                    action="./cancel-company-select.php"
                                    method="post"
                                  >
                                    <input
                                      className="d-none"
                                      value={el?.internDetail?.req_id}
                                      name="req_id"
                                    />
                                    <input
                                      className="d-none"
                                      value={el?.id}
                                      name="st_id"
                                    />
                                    <input
                                      className="d-none"
                                      value={profile?.id}
                                      name="user"
                                    />
                                    <button
                                      className="btn btn-light dropdown-item"
                                      type="submit"
                                    >
                                      ยกเลิกคำร้อง
                                    </button>
                                  </form>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div>
                            <span className="">
                              <WorkHistoryIcon sx={{ fontSize: "16px" }} />{" "}
                              {el.internDetail?.type_internship 
                                ? matchOptions(internType, el.internDetail.type_internship)
                                : <span className="text-muted">-</span>
                              }
                            </span>
                          </div>
                          <div className="d-flex align-items-center justify-content-between">
                            <span className="">
                              <IoMdSchool />{" "}
                              {matchOptions(optionsBranch, el.b_id)}
                            </span>
                          </div>
                          <div>
                            <BiBuildings /> {el?.companyDetail?.name || <span className="text-muted">ไม่มีข้อมูลสถานประกอบการ</span>}{" "}
                          </div>
                          {!el.internDetail && (
                            <div className="alert alert-warning mt-2 p-2 small">
                              ⚠️ ไม่พบข้อมูลคำร้อง
                            </div>
                          )}
                          <div>
                            {/* <span className="ms-4 badge bg-warning text-dark">
                              {getStudents.length} คน
                            </span>
                            <span className="ms-1 badge bg-primary ">
                              {getUniqBranch.length} สาขา
                            </span> */}
                          </div>
                          {el.companyDetail?.id && (
                            <InternPersonsQty
                              companyDetail={joinDataByCompany.find(
                                (c) => c.id == el.companyDetail.id
                              )}
                            />
                          )}

                          <div>
                            {el.status_id == 13 && (
                              <span className="text-danger">
                                รอนิสิตเข้ามาติดต่อ
                              </span>
                            )}
                          </div>

                          <div className="text-end my-2">
                            <img
                              src={`https://reg.buu.ac.th/registrar/getstudentimage.asp?id=${el.id}`}
                              width={50}
                              height={50}
                              className="rounded-circle me-2"
                              alt="Avatar"
                            />
                          </div>
                          <div className="d-flex align-items-center justify-content-between">
                            <button
                              className="btn btn-primary btn-sm "
                              onClick={() => setStudentSelected(el)}
                            >
                              ตรวจสอบ
                            </button>

                            <div>
                              ยื่นมาแล้ว{" "}
                              
                              {el.internDetail?.date_create && timeSince(el.internDetail?.date_create, true)}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>

      {displayDrawer}
    </main>
  );
};

export default Approval;
